import PropTypes from 'prop-types';
import React from 'react';
import Dropzone from 'react-dropzone';

export default class FileDropzone extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    activeClassName: PropTypes.string,
    acceptClassName: PropTypes.string,
    rejectClassName: PropTypes.string,
    disabledClassName: PropTypes.string,
    accept: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onDrop: PropTypes.func.isRequired,
    children: PropTypes.node,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  render() {
    const {
      className,
      activeClassName,
      acceptClassName,
      rejectClassName,
      disabledClassName = 'disabled',
      accept = 'image/*',
      onDrop,
      children,
      multiple = true,
      disabled = false,
    } = this.props;

    return (
      <div className="form-dropzone">
        <Dropzone
          role="button"
          className={className}
          activeClassName={activeClassName}
          acceptClassName={acceptClassName}
          rejectClassName={rejectClassName}
          disabledClassName={disabledClassName}
          accept={Array.isArray(accept) ? accept.join(',') : accept}
          onDrop={onDrop}
          multiple={multiple}
          disabled={disabled}
        >
          {children}
        </Dropzone>
      </div>
    );
  }
}
